import lifebitLogo from '@/assets/images/lifebit-logo.png';

interface LogoIconProps {
  className?: string;
}

export default function LogoIcon({ className = 'w-9 h-9' }: LogoIconProps) {
  return (
    <img
      src={lifebitLogo}
      alt="Lifebit"
      className={`${className} object-contain`}
    />
  );
}
